import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type GetTripsResponse = {
  state: number;
  value: [];
};

export const getArmadoresList = async (): Promise<[]> => {
  try {
    const res = await apiClient.post<GetTripsResponse>(
      Endpoints.ArmadoresList,
      {}
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
